import { navigateWindowTo } from '@ratehub/base-ui';


/**
 * Opens the Ratehub card details page or the provider’s own page in a new window based on if
 * the card is monetized.
 *
 * @param {Object} params
 * @param {boolean} params.isMonetized
 * @param {string} params.applyRedirectURL
 * @param {string} params.detailsURL
 * @param {string} params.applyRedirectURLOverride
 * @param {string} params.queryParams
 */
function navigateNewTabToMoreDetails({
    isMonetized,
    applyRedirectURL,
    detailsURL,
    applyRedirectURLOverride,
    queryParams,
}) {
    navigateWindowTo(
        isMonetized
            ? applyRedirectURLOverride ?? applyRedirectURL
            : applyRedirectURLOverride ?? detailsURL,
        {
            isNewTab: true,
            queryParams,
        },
    );
}

export default navigateNewTabToMoreDetails;
